import { Box } from "@mui/material";
import {
	Datagrid,
	DateField,
	ExportButton,
	FilterButton,
	List,
	ReferenceField,
	SelectInput,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";

const partnerPayoutFilters = [
	<TextInput key="appId" label="App ID" source="appId" />,
	<TextInput key="partnerId" label="Partner ID" source="partnerId" />,
	<TextInput key="appOwnerId" label="App Owner ID" source="appOwnerId" />,
	<SelectInput
		key="status"
		label="Status"
		source="status"
		alwaysOn
		choices={[
			{ id: "queued", name: "Queued" },
			{ id: "processing", name: "Processing" },
			{ id: "transfer_created", name: "Transfer Created" },
			{ id: "paid", name: "Paid" },
			{ id: "failed", name: "Failed" },
			{ id: "reversed", name: "Reversed" },
			{ id: "needs_attention", name: "Needs Attention" },
		]}
	/>,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<ExportButton />
	</TopToolbar>
);

const StatusChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const colors: Record<string, string> = {
		queued: "#9e9e9e",
		processing: "#ff9800",
		transfer_created: "#2196f3",
		paid: "#4caf50",
		failed: "#f44336",
		reversed: "#9c27b0",
		needs_attention: "#e91e63",
	};

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: colors[record.status] || "#757575",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{record.status.replace("_", " ")}
		</Box>
	);
};

const AmountField = () => {
	const record = useRecordContext();
	if (!record) return null;
	return <span>${(record.amountCentsUSD / 100).toFixed(2)} USD</span>;
};

export const PartnerPayoutList = () => (
	<List
		filters={partnerPayoutFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid bulkActionButtons={false}>
			<DateField source="createdAt" label="Created" showTime />
			<StatusChip />
			<AmountField />
			<ReferenceField
				source="partnerId"
				reference="partners"
				label="Partner"
				link="show"
			>
				<TextField source="name" />
			</ReferenceField>
			<ReferenceField source="appId" reference="apps" label="App" link="show">
				<TextField source="name" />
			</ReferenceField>
			<TextField
				source="stripeTransferId"
				label="Stripe Transfer ID"
				emptyText="-"
			/>
			<DateField source="paidAt" label="Paid At" showTime emptyText="-" />
			<TextField source="lastError" label="Last Error" emptyText="-" />
		</Datagrid>
	</List>
);
